module.exports = __webpack_public_path__ + "img/collar length.47a7fb2a.png";